import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  category: string;
  categoryName: string;
  rating: number;
  chapters: number;
  status: string;
  isHot?: boolean;
  isNew?: boolean;
  views?: number;
}

export default function ComicCard({
  id,
  title,
  cover,
  category,
  categoryName,
  rating,
  chapters,
  status,
  isHot,
  isNew,
  views,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

        {(isHot || isNew) && (
          <div className="absolute top-2 left-2 flex gap-1.5">
            {isHot && (
              <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-white rounded-full">
                HOT
              </span>
            )}
            {isNew && (
              <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-foreground-950 rounded-full">
                NEW
              </span>
            )}
          </div>
        )}

        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center justify-between">
            <span className="text-xs text-white/80 bg-black/40 px-2 py-0.5 rounded-full">
              {categoryName}
            </span>
            <span className="flex items-center gap-1 text-xs text-accent-400">
              <i className="ri-star-fill text-[10px]"></i>
              {rating}
            </span>
          </div>
        </div>

        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${
            status === '连载中'
              ? 'bg-accent-500/90 text-foreground-950'
              : 'bg-foreground-500/80 text-white'
          }`}>
            {status}
          </span>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {title}
      </h3>

      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span>共{chapters}话</span>
        {views && (
          <span>
            {views >= 10000
              ? `${(views / 10000).toFixed(1)}万`
              : views}{' '}
            阅读
          </span>
        )}
      </div>
    </Link>
  );
}